import Vue from "vue";
// 自适应
import VScaleScreen from 'v-scale-screen'
Vue.use(VScaleScreen)
